import React from "react";
import PropTypes from "prop-types";
const iso = require("iso-3166-1");
require("amcharts");
require("amcharts.serial");
require("amcharts.themes.light");
require("amcharts.react");
require("ammap");
require("ammap.worldLow");

// const targetSvg =
//   "M10,0C15.519,0 20,4.481 20,10C20,15.519 15.519,20 10,20C4.481,20 0,15.519 0,10C0,4.481 4.481,0 10,0ZM10,7.646C11.299,7.646 12.354,8.701 12.354,10C12.354,11.299 11.299,12.354 10,12.354C8.701,12.354 7.646,11.299 7.646,10C7.646,8.701 8.701,7.646 10,7.646Z";

const targetSvg =
  "M 5, 5 m -3.75, 0 a 3.75,3.75 0 1,0 7.5,0 a 3.75,3.75 0 1,0 -7.5,0";

const graphOptions = (country, lat, long) => ({
  type: "map",
  theme: "light",
  pathToImages: "/img/amcharts/",
  projection: "mercator",
  mouseWheelZoomEnabled: false,
  dragMap: false,
  zoomDuration: 0,
  startDuration: 0,

  zoomControl: {
    zoomControlEnabled: false,
    panControlEnabled: false,
    homeButtonEnabled: false
  },

  imagesSettings: {
    rollOverScale: 1,
    selectedScale: 1,
    selectedColor: "#fff",
    color: "#e87533"
  },

  areasSettings: {
    unlistedAreasColor: "#fff",
    unlistedAreasAlpha: 0.3,
    unlistedAreasOutlineAlpha: 0,
    autoZoom: true,
    outlineThickness: 1,
    outlineAlpha: 0,
    selectedColor: "#fff",
    color: "transparent"
  },

  dataProvider: {
    map: "worldLow",
    getAreasFromMap: true,
    linkToObject: country,
    areas: [
      {
        id: country,
        selectable: false,
        outline: true,
        outlineColor: "#fff",
        outlineAlpha: 1,
        outlineThickness: 2
      }
    ],
    images: [
      {
        svgPath: targetSvg,
        latitude: lat,
        longitude: long
      }
    ]
  }
});

const LocationMap = ({ country, latitude, longitude }) => {
  return (
    <AmCharts.React
      options={graphOptions(
        iso.whereCountry(
          country === "United Kingdom"
            ? "United Kingdom of Great Britain and Northern Ireland"
            : country
        ).alpha2,
        latitude,
        longitude
      )}
      style={{ height: 70 }}
    />
  );
};

LocationMap.propTypes = {
  country: PropTypes.string.isRequired,
  latitude: PropTypes.number.isRequired,
  longitude: PropTypes.number.isRequired
};

export default LocationMap;



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/LocationMap.js